import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import { useSapaChatContext } from '../../context';

export const InfoQuestion = ({ questionId }: { questionId: string }): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.SERVICES);
  const { handleAnswer } = useSapaChatContext();
  return (
    <Button className="mt-4 w-full" onClick={() => handleAnswer(questionId, [])}>
      {t('Sapa.continue.cta')}
    </Button>
  );
};
